import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpParams, HttpClient } from "@angular/common/http";

import { Dogana } from "../models/SearchService/dogana.model";

@Injectable({
  providedIn: "root"
})
export class DoganaHttpClientService {
  private readonly base = environment.backendBaseUrl;
  private readonly endpoint = "/api/dogana";
  private readonly fullPath = `${this.base}${this.endpoint}`;
  private readonly searchURL = `${this.fullPath}/search`;
  private readonly CCURL = `${this.fullPath}/start-cc`;
  private readonly walletURL = `${this.fullPath}/payment/web`;

  constructor(private http: HttpClient) {}

  Search(barcode: string) {
    const params = new HttpParams().set("barcode", barcode);

    return this.http.get<Dogana>(this.searchURL, {
      params
    });
  }

  PayCC(invoice: any) {
    return this.http.post<any>(`${this.CCURL}`, invoice);
  }

  PayWallet(invoice: any) {
    return this.http.post<any>(`${this.walletURL}`, invoice);
  }
}
